import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errMsg } from "@/lib/api";
import { Logo } from "@/components/site/Logo";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("mm_admin_token", data.token);
      navigate("/admin");
    } catch (err) { setError(errMsg(err)); }
    setLoading(false);
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen grid lg:grid-cols-2">
      <div className="hidden lg:flex bg-[var(--mm-red)] items-center justify-center p-16 relative grain"><Logo variant="cream" className="w-full max-w-md h-auto relative" /></div>
      <form onSubmit={submit} className="flex flex-col justify-center px-8 sm:px-20 py-16 max-w-xl w-full mx-auto">
        <Logo className="h-16 lg:hidden mb-10 self-start" />
        <p className="eyebrow text-[var(--mm-red)] mb-3">Atelier</p>
        <h1 className="font-serif-mm text-5xl mb-10">Admin sign in</h1>
        <input data-testid="admin-email-input" type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="field-mm mb-6" />
        <input data-testid="admin-password-input" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className="field-mm mb-6" />
        {error && <p data-testid="admin-login-error" className="text-sm text-[var(--mm-red)] mb-4">{error}</p>}
        <button data-testid="admin-login-button" disabled={loading} className="btn-mm">{loading ? "Signing in…" : "Sign in"}</button>
      </form>
    </div>
  );
}
